import { Pipe, PipeTransform } from '@angular/core';
import { Exercise } from '../../models/Exercises';

@Pipe({
  name: 'categoryfilter',
  pure: false
})
export class CategoryFilter implements PipeTransform {
  transform(items: Exercise[], filter: any): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => item.categories.find(cat => cat._id == filter) != undefined);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/pipes/category-filter/category-filter.pipe.ts